define('app/sf/capitalise/sf-capitalise-filter',[],function () {
	"use strict";
	return sfCapitaliseFilter;
	function sfCapitaliseFilter(value) {
		if (value === undefined || value === null)
			value = "";
		var str = String(value);
		if (!str.length)
			return str;
		return str.charAt(0).toUpperCase() + str.substring(1);
	}
});
